<template>
  <div>
    <section class="tabs">
      <div class="tab-buttons">
        <button
          v-for="tab in localizedTabs"
          :key="tab.id"
          :class="['tab-button', { active: activeTab === tab.id }]"
          @click="selectTab(tab.id)"
        >
          {{ tab.label }}
        </button>
      </div>

      <!-- Tab Contents -->
      <div class="tab-contents">
        <div v-if="activeTab === 'stats-tab'" class="tab-content active" id="stats-tab">
  <!--        <p>Current Tab: {{ activeTab }}</p>-->
          <div class="stats_box">
            <div class="stats_row">
              <p class="title"> {{ getTranslations.home_profile_profile_points }} </p>
              <p class="numb">{{ userDetails.totalPointsEarned }}</p>
            </div>
            <div class="stats_row">
              <p class="title"> {{ getTranslations.home_profile_profile_games }} </p>
              <p class="numb">{{ userDetails.availableGames }}</p>
            </div>
            <div class="stats_row">
              <p class="title">{{ getTranslations.home_profile_completed_achievements }}</p>
              <p class="numb">{{ userDetails.achievements }}</p>
            </div>
            <div class="stats_row">
              <p class="title">{{ getTranslations.home_profile_total_questions }}</p>
              <p class="numb">{{ distinguishedStats.questionsPlayed }}</p>
            </div>
            <div class="stats_row">
              <p class="title">{{ getTranslations.home_profile_wrong_questions }}</p>
              <p class="numb">{{ wrongQuestions }}</p>
            </div>
            <div class="stats_row">
              <p class="title">{{ getTranslations.home_profile_correct_questions }}</p>
              <p class="numb">{{ distinguishedStats.correctQuestions }}</p>
            </div>
            <div class="stats_row">
              <p class="title">{{ getTranslations.home_profile_accuracy_questions }}</p>
              <p class="numb">{{ accuracyQuestions }}</p>
            </div>

          </div>
        </div>
        <div v-if="activeTab === 'achievements-tab'" class="tab-content active" id="achievements-tab">
          <AchievementsProfile @show:achievement="handleShowAchievement"/>
        </div>
      </div>
    </section>

    <AchievementModal
      v-if="achievementModalInfo.open"
      :achievement="achievementModalInfo.achievement"
    />
  </div>

</template>


<script>
  /* eslint no-param-reassign: ["error", { "props": false }], no-console: "off" */
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import 'owl.carousel';
import Vue from 'vue';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import ResumeGame from '@/components/home/modals/ResumeGame';
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import { updateProgressBarGamesWon, updateProgressBarAnswersPercent } from '@/common/jQuery';
import RoundUpMixin from '@/common/mixins/roundUp';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import virtualList from 'vue-virtual-scroll-list';
import AchievementsProfile from "./AchievementsProfile";
import AchievementModal from '../modals/AchievementModal.vue'
import modals from '../../../common/modals'

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  mixins: [NumbersFormattingMixin, RoundUpMixin, FacebookMixin],
  components: {AchievementModal, AchievementsProfile, VirtualList: virtualList },
  data() {
    return {
      tabs: [
        { id: 'stats-tab', translationKey: 'home_profile_tab_stats' },
        { id: 'achievements-tab', translationKey: 'home_profile_tab_achievements' },
      ],
      activeTab: 'achievements-tab',
      action: 'SHARE_VICTORY',
      fb_error: false,
      redirectUrl: '',
      showedModal: false,
      currentPrizeId: '',
      eligibleForReward: false,
      fb_error_share: false,
      achievementModalInfo: {
        open: false,
        achievement: null,
      },
    };
  },
  mounted() {
    this.renderProgressBar();
  },
  updated() {
    this.renderProgressBar();
  },
  created() {
    if (this.hasFbShare()) {
      this.isEligibleForSharePoints({ action: this.action }).then((response) => {
        this.eligibleForReward = response.data;
      });
    }
    this.redirectUrl = `${window.location.href}/${this.getLocale || localStorage.getItem('locale')}/`;
    this.fetchData();
    this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
      // eslint-disable-next-line
      console.log('successful scrapping!');
    });
    this.getUserAchievements();
    this.getUserDistinguishedStats();
  },
  methods: {
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'giveContent',
      'isEligibleForSharePoints',
      'getUserAchievements',
      'getUserDistinguishedStats'
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    selectTab(tabId) {
      this.activeTab = tabId;  // Update the active tab based on the button clicked
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          if (!this.showedModal) {
            console.log("----------------------- Correct DefaultContentProfile For  Store hideModal");
            this.showedModal = true;
            this.storeModalForHomePage(null);
          } else {
            this.storeModalForHomePage(null);
          }
        });
      });
      /* eslint-enable */
    },
    playMethod() {
      console.log('showing resume game pop up in DefaultContentProfile Page...');
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.storeModalForHomePage(ResumeGame);
        } else if (this.userDetails.availableGames === 0 && this.userDetails.subscribed) {
          this.storeModalForHomePage(ZeroBalance);
        } else {
          this.$router.push('/searchingOpponent');
          this.storeModalForHomePage(null);
        }
        this.showModal();
      }).catch(error => console.error(error));
    },
    fetchData() {
      /* eslint-disable */
      this.$nextTick(() => {
        $('.theme-carousel').owlCarousel({
          loop: false,
          responsiveClass: true,
          dots: true,
          autoplay: false,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          navContainer: '.carousel__nav',
          dotsContainer: '.carousel__dots',
          navText: ['<i   class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'],
          responsive: {
            0: {
              items: 4,
              nav: true,
              onInitialized: function() {
                $(".icon-arrow-left").addClass("deactivated");
              },
              onTranslated: function(event){
                $('.icon-arrow-right').removeClass('deactivated');
                $('.icon-arrow-left').removeClass('deactivated');
                if (event.item.index == 0){
                  $(".icon-arrow-left").addClass("deactivated");
                } else {
                  $(".icon-arrow-left").show();
                }
                if (event.item.index == (event.item.count - 4)){
                  $(".icon-arrow-right").addClass("deactivated");
                }
                else {
                  $(".icon-arrow-right").show();
                }
              }
            },
          },
        })
      });
      /* eslint-enable */
    },
    renderProgressBar() {
      // console.clear();
      this.$nextTick(() => {
        updateProgressBarGamesWon(this.gamesWonPercentRatio);
        updateProgressBarAnswersPercent(this.correctAnswersPercentRatio);
      });
    },
    hasFbShare() {
      return this.userDetails.facebookId && this.facebookFunctionality;
    },
    assignPoints() {
      this.giveContent({ action: this.action, points: this.getFbPoints, uniqueId: this.currentPrizeId });
    },
    showError() {
      this.fb_error = true;
    },
    showErrorShare() {
      this.fb_error_share = true;
    },
    shareVictory(prizeId) {
      this.currentPrizeId = prizeId;
      this.fb_error = false;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        this.assignPoints,
        this.showErrorShare,
      );
    },
    handleShowAchievement(achievement) {
      this.achievementModalInfo.achievement = achievement
      this.achievementModalInfo.open = true

      modals.setupCommonModal({
        afterHideCallback: () => {
          this.achievementModalInfo.open = false
          this.achievementModalInfo.achievement = null
        }
      })
    },
  },
  computed: {
    orderedPrizes() {
      return this.userDetails.wonPrizes.slice(0).sort((item1, item2) => item2.awardDate - item1.awardDate);
    },
    getFbPoints() {
      const userPoints = (this.userDetails.facebookId ? this.userDetails.totalPointsEarned : this.userDetails.totalPointsEarned + this.connectionPoints);
      return this.roundUpNumber(Math.floor(userPoints * 0.05));
    },
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapState('common', [
      'userDetails',
      'facebookFunctionality',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'distinguishedStats'
    ]),
    localizedTabs() {
      return this.tabs.map((tab) => ({
        ...tab,
        label: this.getTranslations[tab.translationKey], // Fetch label using translation key
      }));
    },
    wrongQuestions() {
      return this.distinguishedStats.questionsPlayed - this.distinguishedStats.correctQuestions;
    },
    accuracyQuestions() {
      if (this.distinguishedStats.questionsPlayed === 0) {
        return '0%';
      }
      const accuracy = this.distinguishedStats.correctQuestions / this.distinguishedStats.questionsPlayed;
      return `${Math.ceil(accuracy * 100)}%`;
    }
  },
  filters: {
    getMoment(date) {
      return moment(date).format('DD/MM/YYYY'); // .fromNow();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/DefaultContentProfile.vue